import { type CSSProperties, memo } from 'react';

const SHAPE_BOX_MAX_PX = 14;
const SHAPE_BOX_MIN_PX = 5;

const shapeBoxStyle = (width: number, height: number): CSSProperties => {
  const scale = SHAPE_BOX_MAX_PX / Math.max(width, height);

  return {
    height: Math.max(SHAPE_BOX_MIN_PX, Math.round(height * scale)),
    width: Math.max(SHAPE_BOX_MIN_PX, Math.round(width * scale)),
  };
};

export type WorkspaceAgentGuidedVariantSizeShapeProps = {
  height: number;
  width: number;
};

export const WorkspaceAgentGuidedVariantSizeShape = memo(
  ({ height, width }: WorkspaceAgentGuidedVariantSizeShapeProps) => (
    <span aria-hidden className="flex size-4 shrink-0 items-center justify-center">
      <span
        className="rounded-2 border-[1.5px] border-current ads:text-icon-subtle text-gray-9"
        style={shapeBoxStyle(width, height)}
      />
    </span>
  ),
);

WorkspaceAgentGuidedVariantSizeShape.displayName = 'WorkspaceAgentGuidedVariantSizeShape';
